import { BaseActionOverlay } from '@adaptiva/core/overlays';
import { ICveWebView } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'ada-view-cve-info-action-overlay',
	templateUrl: './view-cve-info-action-overlay.component.html',
})
export class ViewCveInfoActionOverlayComponent extends BaseActionOverlay<ICveWebView> implements OnInit {

	public override cancelText: string = 'Close'; 

	public override showConfirmButton: boolean = false;

	public ngOnInit(): void {
		if (this.context)
			this.applyContext(this.context);

		this.ready.next(true);
	}

	protected override applyContext(_cveWebView: ICveWebView): void {
		this.title = `Viewing: ${_cveWebView.cveId}`;
	}
}
